export default __webpack_public_path__ + "static/media/drinkaware.9473843f.png";